<template>
  <div :class="$style.vipCustomer">
    <div :class="$style.container">
      <VipCustomer 
        isH5="true" 
        @close="close" 
        @openUrl="openUrl"
      ></VipCustomer>
    </div>
  </div>
</template>

<script>
import VipCustomer from "@/components/VipCustomer";
import { gameOpenDownloads } from "@/bridge/AppJsBridge";

export default {
  name: "",
  data() {
    return {
      appkey: "",
      user_id: ""
    };
  },
  components: {
    VipCustomer
  },
  methods: {
    close() {
      this.$emit("close");
    },
    openUrl(url) {
      gameOpenDownloads({ gameUrl: url });
    }
  }
};
</script>

<style lang="scss" module>
.vipCustomer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  background: rgba(0, 0, 0, 0.6);
  .container {
    width: 3.75rem;
    height: 2.6rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    @media screen and (orientation: portrait) {
      width: 90%;
      height: 85%;
    }
  }
}
</style>